import React, { ReactNode } from 'react';
import styled from 'styled-components';
import Icon from '../components/Icon';
import ICONS from '../constants/icons';
import { MQS, NOTIFICATIONS } from '../constants/styles';
import { NotificationType } from './notificationType.enum';

export interface INotificationProps extends IBannerProps {
    title?: ReactNode;
    message: ReactNode;
    onDismiss?: any;
    qaId?: string;
}
interface IBannerProps {
    type: NotificationType;
    blockUI?: boolean;
    nonDismissable?: boolean;
}
const NotificationBanner = styled.div`
    background-color: ${(props: IBannerProps) => NOTIFICATIONS[props.type].background};
    border-radius: 8px;
    color: ${(props: IBannerProps) => NOTIFICATIONS[props.type].color};
    min-height: 60px;
    padding: 12px 8px 20px 16px;

    margin: auto;
    display: flex;
    gap: 12px;

    .container {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding-top: 8px;
    }

    .title {
        font-weight: 700;
    }

    .icon {
        flex-shrink: 0;
    }

    .close {
        border: none;
        background: none;
        color: inherit;
        margin-left: auto;
        padding: 10px 12px;
        height: fit-content;
        cursor: pointer;
    }

    @media (max-width: ${MQS.mq2Min}) {
        font-size: 0.875rem;
        padding: 20px;
    }
`;

export default class Notification extends React.Component<INotificationProps> {
    public render() {
        const { type, blockUI, title, message, onDismiss, qaId } = this.props;
        const icon = NOTIFICATIONS[this.props.type].icon;
        const dismissButton = this.props.nonDismissable ? null : (
            <button className="close" onClick={onDismiss} data-qa-id={`${qaId}-dismiss`}>
                <Icon size="14" icon={ICONS.CLOSE} />
            </button>
        );

        return (
            <NotificationBanner type={type} blockUI={blockUI} data-qa-id={qaId}>
                <Icon className="icon" size="30" icon={icon} />
                <div className="container">
                    {title && <div className="title">{title}</div>}
                    <div>{message}</div>
                </div>
                {dismissButton}
            </NotificationBanner>
        );
    }
}
